import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { AAT_OPTIONS, AMU_OPTIONS, vitalUnitListEmpty, vitalUnitListMetric, vitalUnitListUS } from "../../Components/Constants";
import PracticeDetailsPrintPopup from "../../Components/PracticeDetailsPrintPopup";
import FormatPhoneNumber from "../../../../../../../../../utils/FormatPhoneNumber";
import SignImagePreview from "../../Components/SignImagePreview";
import { formatDateTimeWithAt } from "../../Components/FormatDateTimeWithAt";
import MapItemsObjectiveFindings from './ObjectiveFinding/MapItemsObjectiveFindings';
import { renderLeftRight } from "./utils";
// import { HPI_GROUPS, ROS_GROUPS } from "../../Components/utils";
import CustomTemplateFormPreview from "../../Components/Custom Template Form/CustomTemplateFormPreview";
import { isSignedOrToBeCoSigned } from "../../Components/utils";
import SignData from "../../Components/SignData";
import EncDateStatus from "../../Components/Encounter Print Popup/EncDateStatus";

const SelectedPreviewDataV2 = ({ selectedItems, data, Data, searchParam, searchValue, ...props }) => {
    let { showAddressTypeLocation } = props;
    console.log("showAddressTypeLocation", showAddressTypeLocation)
    // let DropDowns = useSelector(state => state.GeneralDropDownsReducer);
    let { ObjectiveFinding: objectiveFinding, RangeOfMotion: rangeOfMotion } = { ...Data };
    // let systemVitals = data?.Vital?.[0]?.Vital?.reduce((acc, curr) => {
    //     acc[curr.VitalName] = curr.VitalValue;
    //     return acc;
    // }, {});
    // let vitalData = Data?.vitalData?.reduce((acc, curr) => {
    //     acc[curr.VitalName] = curr.VitalValue || systemVitals?.[curr.VitalName];
    //     return acc;
    // }, {});

    const isVisuallyEmpty = (html = '') => {
        return html.replace(/<[^>]*>/g, '').trim() === '';
    }

    const removeTrailingEmptyLines = (html) => {
        return html.replace(/(<p><br><\/p>\s*)+$/g, '');
    }

    let noValExistTextNA = <p className="text ar-light-color">N/A</p>;
    // let noValExistVitalTextNA = <span className="text ar-light-color">N/A</span>;
    let noValExistText = <p className="text ar-light-color">No data recorded</p>;
    console.log("AssesmentNotesAssesmentNotes", Data)

    let subjectiveNoteText = removeTrailingEmptyLines(Data?.SubjectiveNotes || '');
    let palpationNoteText = removeTrailingEmptyLines(objectiveFinding?.PalpationNotes || '');
    let objectiveNoteText = removeTrailingEmptyLines(Data?.ObjectiveNotes || '');
    let focusAreaNoteText = removeTrailingEmptyLines(Data?.AssessmentAreaTreated?.AAT_FocusArea || '');
    let assesmentNoteText = removeTrailingEmptyLines(Data?.AssesmentNotes || '');
    let planNoteText = removeTrailingEmptyLines(Data?.PlanNotes || '');
    let homeExerciseProgramNoteText = removeTrailingEmptyLines(Data?.HomeExerciseProgram || '');
    let followUpNotesText = removeTrailingEmptyLines(Data?.FollowUpNotes || '');
    let additionalNoteText = removeTrailingEmptyLines(Data?.AdditionalInfoNotes || '');

    const vitalUnitListPreview = useMemo(() => {
        if (searchParam?.VitalUnitType === "US Customary") {
            return vitalUnitListUS;
        } else if (searchParam?.VitalUnitType === "Metric") {
            return vitalUnitListMetric;
        }
        return vitalUnitListEmpty; // fallback empty object
    }, [searchParam?.VitalUnitType]);
    console.log("data Data 123", data, Data,)

    const formattedUTC = data?.Data?.CurrentPracticeTime;
    let signatureDateTimeFormatted = formatDateTimeWithAt(data?.Data?.ProviderSignatureDate)
    let formattedUTCBottom = formattedUTC?.replace(',', ' at');
    const CustomTemplateData = Data?.CustomTemplateData?.[0];
    const EncounterCoSignData = Data?.EncounterCoSignData?.filter(enc => [ true, "true"].includes(enc.isCoSigned));
        const ThemeConfiguration = useSelector((state) => state.Theme?.theme) || JSON.parse(localStorage.getItem("themeConfig") || "null");
    return (<>
        {/* {selectedItems?.patientSummary && */}
        <div className='d-flex flex-column gap-10 mb-15'>
            {/* <div className="d-flex align-items-center justify-content-between pb-1-5 br-bottom-1 za_br_light">
                    <p className="text fs-11 ar-light-color">{formattedUTC}</p>
                    <p className='text fs-11 ar-light-color'>{data?.Data?.UserName ? `(${data?.Data?.UserName})` : ''} {data?.Data?.PracticeShortName}</p>
                </div> */}
            <div className="d-flex align-items-center justify-content-center gap-12 pat-det-header">
                <div className="d-flex align-items-center gap-1">
                    <p className='heading text-white'>{data?.Data?.PatientName}</p>
                    <p className='text text-white'>{data?.Data?.DOB}</p>
                    <p className='text text-white'>{data?.Data?.Age ? `(${data?.Data?.Age})` : ''}</p>
                    <p className='text text-white'>{data?.Data?.Gender}</p>
                </div>
                <div className="text light-clrs">|</div>
                <div className="d-flex align-items-center gap-1">
                    <p className='text font-m text-white'>Account #</p>
                    <p className="text text-white">{data?.Data?.AccountNumber || noValExistTextNA}</p>
                </div>
                <div className="text light-clrs">|</div>
                <div className="d-flex align-items-center gap-1">
                    <p className='text font-m text-white'>DOS:</p>
                    <p className="text text-white">{searchParam?.EncounterDate || noValExistTextNA}</p>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                {console.log("dataqwertData", data?.Data)}
                <PracticeDetailsPrintPopup data={data?.Data} />
            </div>
            <div className=''>
                <div className="encounter-edit-mode-pdf p-2 d-flex flex-column gap-1">
                    <div className="col-md-12 p-0 d-flex gap-1">
                        <p className="heading validate-color fs-16 lh-15">{data?.Data?.PatientName}</p>
                        <span className='d-flex gap-1 align-items-center'>
                            <span className='text text-black'>{data?.Data?.DOB}</span> <span className='text text-black'>{data?.Data?.Age ? `(${data?.Data?.Age})` : ''}</span> <span className='text text-black'>{data?.Data?.Gender}</span>
                        </span>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Account #</p>
                                <p className="text text-black">{data?.Data?.AccountNumber || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Phone:</p>
                                <p className="text text-black">{data?.Data?.MobileNumber ? FormatPhoneNumber(data?.Data?.MobileNumber) : noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Address:</p>
                                <p className="text text-black">
                                    {selectedItems?.patientSummary ?
                                        (([true, "true"].includes(showAddressTypeLocation) ?
                                            data?.Data?.FacilityAddress : data?.Data?.Address)
                                            || noValExistTextNA) : noValExistTextNA}
                                </p>
                            </div>
                        </div>

                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Provider:</p>
                                <p className="heading validate-color">{searchValue.SeenBy || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Insurance:</p>
                                <p className="text text-black">{data?.Data?.InsuranceName || noValExistTextNA}</p>
                            </div>
                            <div className="d-flex align-items-center gap-1">
                                <p className="text font-m w-72px text-black">Location:</p>
                                <p className="text text-black">{searchValue?.Facility || noValExistTextNA}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
                <EncDateStatus searchParam={searchParam} searchValue={searchValue} noValExistTextNA={noValExistTextNA} data={data} Data={Data}/>

                <div className="d-flex align-items-center gap-2">
                    <div className="d-flex align-items-center gap-1">
                        <p className="heading validate-color">Encounter Type:</p>
                        {searchValue?.EncounterType ?
                            <span className="text validate-color">{searchValue.EncounterType}</span>
                            :
                            <>{noValExistTextNA}</>}
                    </div>

                    <div className="d-flex align-items-center gap-1">
                        <p className="heading validate-color">Note Type:</p>
                        {searchValue?.NoteType ?
                            <span className="text validate-color">{searchValue.NoteType}</span>
                            :
                            <>{noValExistTextNA}</>}
                    </div>
                </div>
                {/* {searchValue?.EncounterType && searchValue?.NoteType && <span> - </span>}
                        {searchValue?.NoteType && <span>{searchValue.NoteType}:</span>} */}
                {/* {searchValue?.SeenBy && <span> {searchValue.SeenBy}</span>} */}

            </div>

        </div>
        {/* } */}
        <div className="d-flex flex-column gap-10">
            {selectedItems?.customTemplateClinical &&
                (CustomTemplateData?.InsertPosition === "Top" ?
                    <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>)}
            {selectedItems?.chiefComplaint &&
                <div>
                    <div className="d-flex flex-column gap-6">
                        <div className="d-flex">
                            <p className='text fs-14 font-b validate-color blue-bg'>Chief Complaint</p>
                        </div>
                        <p className="text text-black">{Data?.ChiefComplaint || noValExistText}</p>
                    </div>
                </div>}
            {selectedItems?.problems &&
                <div>
                    <div className="d-flex flex-column gap-6">
                        <div className="d-flex">
                            <p class="text fs-14 font-b validate-color blue-bg">Problems</p>
                        </div>


                        {Data?.EncounterProblem?.length > 0 ?

                            <div className="d-flex flex-column gap-1">
                                {Data.EncounterProblem.map((prob) => (
                                    <div className="d-flex align-items-center gap-1">
                                        <p className='text font-m validate-color'>{prob.DiagnosisCode}</p>
                                        <p className="text text-black">{prob.Description && `- ${prob.Description}${prob.StartDate ? ',' : ''}`}</p>
                                        {prob.StartDate ?
                                            (<div className="d-flex align-items-center gap-1">
                                                <p className='heading text-black'>Start Date:</p>
                                                <p className='text text-black'>{prob.StartDate || <span className="text fs-11 ar-light-color fst-italic">N/A</span>}</p>
                                            </div>) : <></>}
                                    </div>
                                )
                                )}
                            </div> :
                            <>{noValExistText}</>}
                    </div>
                </div>}

            {selectedItems?.subjectiveNotes &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">SUBJECTIVE</p>
                    </div>
                    <div>
                        {isVisuallyEmpty(subjectiveNoteText) ?
                            noValExistText :
                            <p className="text text-black" dangerouslySetInnerHTML={{ __html: subjectiveNoteText }}></p>}
                    </div>
                </div>}
            {(selectedItems?.objective || (selectedItems?.objectiveFindings || selectedItems?.objectiveNotes)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">OBJECTIVE</p>
                    </div>
                    {selectedItems?.objectiveFindings &&
                        <div className="">
                            <p className="heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3">Objective Findings</p>
                            <div className="d-flex align-items-center gap-40 row-gap-5 flex-wrap mb-06-px">
                                {objectiveFinding?.PostureAssessmentOfSpine === "true" &&
                                    <div className="d-flex align-items-center gap-6 blue-tick">
                                        <i className="icon-check fs-15 fw-900"></i>
                                        <p className="text">Posture Assessment of Spine</p>
                                    </div>}
                                {objectiveFinding?.PostureAssessmentOfPelvis === "true" &&
                                    <div className="d-flex align-items-center gap-6 blue-tick">
                                        <i className="icon-check fs-15 fw-900"></i>
                                        <p className="text">Posture Assessment of Pelvis</p>
                                    </div>}
                                {objectiveFinding?.PostureAssessmentOfShoulder === "true" &&
                                    <div className="d-flex align-items-center gap-6 blue-tick">
                                        <i className="icon-check fs-15 fw-900"></i>
                                        <p className="text">Posture Assessment of Shoulder</p>
                                    </div>}
                                {objectiveFinding?.RangeOfMotion === "true" &&
                                    <div className="d-flex align-items-center gap-6 blue-tick">
                                        <i className="icon-check fs-15 fw-900"></i>
                                        <p className="text">Range of Motion (ROM)</p>
                                    </div>}
                                {objectiveFinding?.Palpation === "true" &&
                                    <div className="d-flex align-items-center gap-6 blue-tick">
                                        <i className="icon-check fs-15 fw-900"></i>
                                        <p className="text">Palpation</p>
                                    </div>}
                            </div>

                            {(objectiveFinding?.PostureAssessmentOfSpine === "true" ||
                                objectiveFinding?.PostureAssessmentOfPelvis === "true" ||
                                objectiveFinding?.PostureAssessmentOfShoulder === "true" ||
                                objectiveFinding?.RangeOfMotion === "true" ||
                                objectiveFinding?.Palpation === "true") &&
                                <div className="ar-observation-content d-flex flex-column gap-2">
                                    <div className="d-flex align-items-center justify-content-between gap-20">
                                        {objectiveFinding?.PostureAssessmentOfSpine === "true" &&
                                            <div className="">
                                                <p className="heading fs-13 text-decoration-underline letter-spacing-1-3 pb-1">Posture Assessment of Spine:</p>
                                                <MapItemsObjectiveFindings items={['Lordosis', 'Kyphosis', 'Scoliosis']} type={'PAOS'} objectiveFinding={objectiveFinding} />
                                            </div>}
                                        {objectiveFinding?.PostureAssessmentOfPelvis === "true" &&
                                            <div className="">
                                                <p className="heading fs-13 text-decoration-underline letter-spacing-1-3 pb-1">Posture Assessment of Pelvis:</p>
                                                <MapItemsObjectiveFindings items={['Tilt', 'Twist', 'Protraction', 'Retraction']} type={'PAOP'} objectiveFinding={objectiveFinding} />
                                            </div>}
                                        {objectiveFinding?.PostureAssessmentOfShoulder === "true" &&
                                            <div className="">
                                                <p className="heading fs-13 text-decoration-underline letter-spacing-1-3 pb-1">Posture Assessment of Shoulder:</p>
                                                <MapItemsObjectiveFindings items={['Tilt', 'Twist', 'Protraction']} type={'PAOSH'} objectiveFinding={objectiveFinding} />
                                            </div>}
                                    </div>

                                    <div className="d-flex flex-column gap-2">
                                        {objectiveFinding?.RangeOfMotion === "true" &&
                                            <>
                                                <div className="">
                                                    <p className='heading fs-13 text-decoration-underline letter-spacing-1-3 pb-1'>Range of Motion (ROM):</p>
                                                    {(rangeOfMotion?.CervicalSpine === "true" ||
                                                        rangeOfMotion?.ThoracicLumberSpine === "true" ||
                                                        rangeOfMotion?.Shoulder === "true" ||
                                                        rangeOfMotion?.Elbow === "true" ||
                                                        rangeOfMotion?.Forearm === "true" ||
                                                        rangeOfMotion?.Wrist === "true" ||
                                                        rangeOfMotion?.Hip === "true" ||
                                                        rangeOfMotion?.Knee === "true" ||
                                                        rangeOfMotion?.Ankle === "true") &&
                                                        <div className="d-flex align-items-center gap-12 row-gap-5 flex-wrap">
                                                            {rangeOfMotion?.CervicalSpine === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Cervical Spine</p>
                                                                </div>}

                                                            {rangeOfMotion?.ThoracicLumberSpine === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Thoracic & Lumbar Spine</p>
                                                                </div>}

                                                            {rangeOfMotion?.Shoulder === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Shoulder</p>
                                                                </div>}

                                                            {rangeOfMotion?.Elbow === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Elbow</p>
                                                                </div>}

                                                            {rangeOfMotion?.Forearm === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Forearm</p>
                                                                </div>}

                                                            {rangeOfMotion?.Wrist === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Wrist</p>
                                                                </div>}

                                                            {rangeOfMotion?.Hip === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Hip</p>
                                                                </div>}

                                                            {rangeOfMotion?.Knee === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Knee</p>
                                                                </div>}

                                                            {rangeOfMotion?.Ankle === "true" &&
                                                                <div className="d-flex align-items-center gap-6 blue-tick">
                                                                    <i className="icon-check fs-15 fw-900"></i>
                                                                    <p className="text">Ankle</p>
                                                                </div>}
                                                        </div>}
                                                    {!(rangeOfMotion?.CervicalSpine === "true" ||
                                                        rangeOfMotion?.ThoracicLumberSpine === "true" ||
                                                        rangeOfMotion?.Shoulder === "true" ||
                                                        rangeOfMotion?.Elbow === "true" ||
                                                        rangeOfMotion?.Forearm === "true" ||
                                                        rangeOfMotion?.Wrist === "true" ||
                                                        rangeOfMotion?.Hip === "true" ||
                                                        rangeOfMotion?.Knee === "true" ||
                                                        rangeOfMotion?.Ankle === "true") && noValExistText}
                                                </div>
                                                {/* Cervical Spine ROM */}
                                                {rangeOfMotion?.CervicalSpine === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Cervical Spine ROM</p>
                                                            {rangeOfMotion?.CS_Flexion ?
                                                                <div className="d-flex align-items-center gap-01">
                                                                    <p className="heading ar_dot">Flexion:</p>
                                                                    <p className="text">{rangeOfMotion?.CS_Flexion || noValExistTextNA}</p>
                                                                </div> : <></>}
                                                            {rangeOfMotion?.CS_Extension ?
                                                                <div className="d-flex align-items-center gap-01">
                                                                    <p className="heading ar_dot">Extension:</p>
                                                                    <p className="text">{rangeOfMotion?.CS_Extension || noValExistTextNA}</p>
                                                                </div> : <></>}
                                                            {renderLeftRight(rangeOfMotion?.CS_LateralFlexionLeft, rangeOfMotion?.CS_LateralFlexionRight, 'Lateral Flexion')}
                                                            {renderLeftRight(rangeOfMotion?.CS_RotationLeft, rangeOfMotion?.CS_RotationRight, 'Rotation')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.CS_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                                {/* Thoracic & Lumbar Spine ROM */}
                                                {rangeOfMotion?.ThoracicLumberSpine === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Thoracic & Lumbar Spine ROM</p>
                                                            {rangeOfMotion?.TLS_Flexion ?
                                                                <div className="d-flex align-items-center gap-01">
                                                                    <p className="heading ar_dot">Flexion:</p>
                                                                    <p className="text">{rangeOfMotion?.TLS_Flexion || noValExistTextNA}</p>
                                                                </div> : <></>}
                                                            {rangeOfMotion?.TLS_Extension ?
                                                                <div className="d-flex align-items-center gap-01">
                                                                    <p className="heading ar_dot">Extension:</p>
                                                                    <p className="text">{rangeOfMotion?.TLS_Extension || noValExistTextNA}</p>
                                                                </div> : <></>}
                                                            {renderLeftRight(rangeOfMotion?.TLS_LateralFlexionLeft, rangeOfMotion?.TLS_LateralFlexionRight, 'Lateral Flexion')}
                                                            {renderLeftRight(rangeOfMotion?.TLS_RotationLeft, rangeOfMotion?.TLS_RotationRight, 'Rotation')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.TLS_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                                {/* Shoulder */}
                                                {rangeOfMotion?.Shoulder === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Shoulder ROM</p>
                                                            {renderLeftRight(rangeOfMotion?.Shoulder_FlexionLeft, rangeOfMotion?.Shoulder_FlexionRight, 'Flexion')}
                                                            {renderLeftRight(rangeOfMotion?.Shoulder_ExtensionLeft, rangeOfMotion?.Shoulder_ExtensionRight, 'Extension')}
                                                            {renderLeftRight(rangeOfMotion?.Shoulder_AbductionLeft, rangeOfMotion?.Shoulder_AbductionRight, 'Abduction')}
                                                            {renderLeftRight(rangeOfMotion?.Shoulder_AdductionLeft, rangeOfMotion?.Shoulder_AdductionRight, 'Adduction')}
                                                            {renderLeftRight(rangeOfMotion?.Shoulder_InternalRotationLeft, rangeOfMotion?.Shoulder_InternalRotationRight, 'Internal Rotation')}
                                                            {renderLeftRight(rangeOfMotion?.Shoulder_ExternalRotationLeft, rangeOfMotion?.Shoulder_ExternalRotationRight, 'External Rotation')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.Shoulder_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                                {/* Elbow */}
                                                {rangeOfMotion?.Elbow === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Elbow ROM</p>
                                                            {renderLeftRight(rangeOfMotion?.Elbow_FlexionLeft, rangeOfMotion?.Elbow_FlexionRight, 'Flexion')}
                                                            {renderLeftRight(rangeOfMotion?.Elbow_ExtensionLeft, rangeOfMotion?.Elbow_ExtensionRight, 'Extension')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.Elbow_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                                {/* Forearm */}
                                                {rangeOfMotion?.Forearm === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Forearm  ROM</p>
                                                            {renderLeftRight(rangeOfMotion?.Forearm_PronationLeft, rangeOfMotion?.Forearm_PronationRight, 'Pronation')}
                                                            {renderLeftRight(rangeOfMotion?.Forearm_SupinationLeft, rangeOfMotion?.Forearm_SupinationRight, 'Supination')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.Forearm_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                                {/* Wrist */}
                                                {rangeOfMotion?.Wrist === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Wrist ROM</p>
                                                            {renderLeftRight(rangeOfMotion?.Wrist_FlexionLeft, rangeOfMotion?.Wrist_FlexionRight, 'Flexion')}
                                                            {renderLeftRight(rangeOfMotion?.Wrist_ExtensionLeft, rangeOfMotion?.Wrist_ExtensionRight, 'Extension')}
                                                            {renderLeftRight(rangeOfMotion?.Wrist_RadialDeviationLeft, rangeOfMotion?.Wrist_RadialDeviationRight, 'Radial Deviation')}
                                                            {renderLeftRight(rangeOfMotion?.Wrist_UlnarDeviationLeft, rangeOfMotion?.Wrist_UlnarDeviationRight, 'Ulnar Deviation')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.Wrist_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                                {/* Hip */}
                                                {rangeOfMotion?.Hip === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Hip ROM</p>
                                                            {renderLeftRight(rangeOfMotion?.Hip_FlexionLeft, rangeOfMotion?.Hip_FlexionRight, 'Flexion')}
                                                            {renderLeftRight(rangeOfMotion?.Hip_ExtensionLeft, rangeOfMotion?.Hip_ExtensionRight, 'Extension')}
                                                            {renderLeftRight(rangeOfMotion?.Hip_AbductionLeft, rangeOfMotion?.Hip_AbductionRight, 'Abduction')}
                                                            {renderLeftRight(rangeOfMotion?.Hip_AdductionLeft, rangeOfMotion?.Hip_AdductionRight, 'Adduction')}
                                                            {renderLeftRight(rangeOfMotion?.Hip_InternalRotationLeft, rangeOfMotion?.Hip_InternalRotationRight, 'Internal Rotation')}
                                                            {renderLeftRight(rangeOfMotion?.Hip_ExternalRotationLeft, rangeOfMotion?.Hip_ExternalRotationRight, 'External Rotation')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.Hip_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                                {/* Knee */}
                                                {rangeOfMotion?.Knee === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Knee ROM</p>
                                                            {renderLeftRight(rangeOfMotion?.Knee_FlexionLeft, rangeOfMotion?.Knee_FlexionRight, 'Flexion')}
                                                            {renderLeftRight(rangeOfMotion?.Knee_ExtensionLeft, rangeOfMotion?.Knee_ExtensionRight, 'Extension')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.Knee_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                                {/* Ankle */}
                                                {rangeOfMotion?.Ankle === "true" &&
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="">
                                                            <p className="heading pb-2px">Ankle ROM</p>
                                                            {renderLeftRight(rangeOfMotion?.Ankle_PlantarflexionLeft, rangeOfMotion?.Ankle_PlantarflexionRight, 'Plantarflexion')}
                                                            {renderLeftRight(rangeOfMotion?.Ankle_DorsiflexionLeft, rangeOfMotion?.Ankle_DorsiflexionRight, 'Dorsiflexion')}
                                                        </div>
                                                        <div className="">
                                                            <p className="heading">Notes :</p>
                                                            <p className="text">{rangeOfMotion?.Ankle_Notes || noValExistTextNA}</p>
                                                        </div>
                                                    </div>}
                                            </>}
                                    </div>

                                    {objectiveFinding?.Palpation === 'true' ?
                                        <div className="">
                                            <p className="heading fs-13 text-decoration-underline letter-spacing-1-3 pb-1">Palpation:</p>
                                            <div>
                                                {isVisuallyEmpty(objectiveFinding.PalpationNotes) ?
                                                    noValExistText :
                                                    <p className="text" dangerouslySetInnerHTML={{ __html: palpationNoteText }}></p>}
                                            </div>
                                        </div> : <></>}
                                </div>}
                            {!(objectiveFinding?.PostureAssessmentOfSpine === "true" ||
                                objectiveFinding?.PostureAssessmentOfPelvis === "true" ||
                                objectiveFinding?.PostureAssessmentOfShoulder === "true" ||
                                objectiveFinding?.RangeOfMotion === "true" ||
                                objectiveFinding?.Palpation === "true") && noValExistText}

                        </div>}
                    {selectedItems?.objectiveNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(objectiveNoteText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: objectiveNoteText || '' }}></p>}

                                {/* {Data?.ObjectiveNotes.trim() ? <></> : noValExistText} */}
                            </div>
                        </div>}
                </div>}
            {(selectedItems?.assessment || (selectedItems?.assessmentAreaTreated || selectedItems?.focusArea || selectedItems?.assessmentMethodUsed || selectedItems?.assessmentNotes)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">ASSESSMENT</p>
                    </div>
                    {/* Area Treated */}
                    {selectedItems?.assessmentAreaTreated &&
                        (<div className="">
                            <p className="heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3">Areas Treated</p>
                            <div className="d-flex align-items-center gap-12 row-gap-5 flex-wrap">
                                {AAT_OPTIONS
                                    .filter(({ key }) => Data?.AssessmentAreaTreated?.[key] === "true")
                                    .map(({ label, key }) => (
                                        <div key={key} className="d-flex align-items-center gap-6 blue-tick">
                                            <i className="icon-check fs-15 fw-900"></i>
                                            <p className="text">{label}</p>
                                        </div>
                                    ))}
                                {AAT_OPTIONS.filter(({ key }) => Data?.AssessmentAreaTreated?.[key] === "true").length === 0 ? noValExistText : <></>}
                            </div>
                        </div>)}
                    {/* Focus Area */}
                    {selectedItems?.focusArea &&
                        (<div>
                            <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Focus Area</p>
                            <div>
                                {isVisuallyEmpty(Data?.AssessmentAreaTreated?.AAT_FocusArea) ?
                                    noValExistText :
                                    <p className="text" dangerouslySetInnerHTML={{ __html: focusAreaNoteText }}></p>}
                            </div>
                        </div>)}
                    {/* Methods Used */}
                    {selectedItems?.assessmentMethodUsed &&
                        (<div className="">
                            <p className="heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3">Methods Used</p>
                            <div className="d-flex align-items-center gap-12 row-gap-5 flex-wrap">
                                {AMU_OPTIONS
                                    .filter(({ key }) => Data?.AssessmentMethodUsed?.[key] === "true")
                                    .map(({ label, key }) => (
                                        <div key={key} className="d-flex align-items-center gap-6 blue-tick">
                                            <i className="icon-check fs-15 fw-900"></i>
                                            <p className="text">{label}</p>
                                        </div>
                                    ))}
                                {AMU_OPTIONS.filter(({ key }) => Data?.AssessmentMethodUsed?.[key] === "true").length === 0 ? noValExistText : <></>}
                            </div>
                        </div>)}
                    {selectedItems?.assessmentNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(assesmentNoteText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: assesmentNoteText }}></p>}
                            </div>
                        </div>}
                </div>}
            {(selectedItems?.plan || selectedItems?.planNotes || selectedItems?.homeExerciseProgram || selectedItems?.followUp) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">PLAN</p>
                    </div>

                    {selectedItems?.planNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(planNoteText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: planNoteText }}></p>}
                            </div>
                        </div>}
                    {selectedItems?.homeExerciseProgram &&
                        <div>
                            <p className='heading fs-13 pb-1 lh-15 text-decoration-underline letter-spacing-1-3 '>Home Exercise Program(HEP)</p>
                            <div>
                                {isVisuallyEmpty(Data.HomeExerciseProgram) ?
                                    noValExistText :
                                    <p className="text" dangerouslySetInnerHTML={{ __html: homeExerciseProgramNoteText }}></p>}
                            </div>
                        </div>}
                    {selectedItems?.followUp &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Follow-Up</p>
                            {isVisuallyEmpty(Data.FollowUpNotes) && !(Data?.FollowUpDate) ?
                                noValExistText :
                                <div>
                                    <div className="d-flex gap-1 text-nowrap mb-1">
                                        <p className='heading'>Follow-Up Date:</p>
                                        <p className='text'>{Data?.FollowUpDate || <span className="text ar-light-color">N/A</span>},</p>
                                    </div>
                                    <div className="d-flex flex-column gap-1">
                                        <p className='heading lh-12'>Notes:</p>
                                        {isVisuallyEmpty(Data.FollowUpNotes) ?
                                            noValExistText :
                                            <p className="text" dangerouslySetInnerHTML={{ __html: followUpNotesText }}></p>}
                                    </div>
                                </div>
                            }
                        </div>
                    }
                </div>}
            {selectedItems?.customTemplateClinical &&
                (CustomTemplateData?.InsertPosition === "Bottom" ?
                    <CustomTemplateFormPreview CustomTemplateData={CustomTemplateData}/> : <></>)}
            {(selectedItems?.additionalInfo || (selectedItems?.documents || selectedItems?.additionalNotes)) &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex align-items-center justify-content-between">
                        <p class="text fs-14 font-b validate-color blue-bg">Additional INFO</p>
                    </div>
                    {selectedItems?.documents &&
                        <div>
                            <p class="heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black">Documents</p>
                            {Data?.EncounterDocument?.length > 0 ?
                                <div className="d-flex flex-column gap-1">
                                    {Data.EncounterDocument.map((doc) => (
                                        <div className="d-flex align-items-center gap-1">
                                            <p className='text font-m validate-color'>{doc.FileName}</p>
                                            <p className="text text-black">{doc.Description && `- ${doc.Description}`}</p>
                                        </div>
                                    )
                                    )}
                                </div> :
                                <>{noValExistText}</>}
                        </div>}
                    {selectedItems?.additionalNotes &&
                        <div>
                            <p className='heading fs-13 pb-1 text-decoration-underline letter-spacing-1-3 text-black'>Notes</p>
                            <div>
                                {isVisuallyEmpty(additionalNoteText) ?
                                    noValExistText :
                                    <p className="text text-black" dangerouslySetInnerHTML={{ __html: additionalNoteText }}></p>}
                            </div>
                        </div>}
                </div>}
            {selectedItems?.procedureCodes &&
                <div className="d-flex flex-column gap-6">
                    <div className="d-flex">
                        <p class="text fs-14 font-b validate-color blue-bg">Procedure Codes</p>
                    </div>
                    {Data?.mainServiceLineModal?.length > 0 ?
                        <div className="d-flex flex-column gap-1">
                            {Data.mainServiceLineModal.map((data) => {
                                let modifiersExists = [data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4].filter(Boolean)?.length > 0;
                                return (
                                    <div className="d-flex align-items-center gap-1 flex-wrap">
                                        <p className='text font-m validate-color'>{data?.ProcedureCode}</p>
                                        {data?.ProcedureDescription ? <p className="text text-black">{data?.ProcedureDescription && `- ${data.ProcedureDescription}`}</p> : null}
                                        {modifiersExists ?
                                            (<div className="d-flex align-items-center gap-1">
                                                <p className="text text-black font-m">Modifiers:</p>
                                                <p className="heading text-black">
                                                    {[data.ModifierCode1, data.ModifierCode2, data.ModifierCode3, data.ModifierCode4]
                                                        .filter(Boolean).join(', ')}
                                                    {data?.Units && !['1', 1, '1.00'].includes(data.Units) && ', '}
                                                </p>
                                            </div>) : <></>}
                                        {((data?.Units) && !['1', 1, "1.00"].includes(data.Units)) ?
                                            (<div className="d-flex align-items-center gap-1">
                                                <p className="text text-black font-m">Units:</p>
                                                <p className="heading text-black">
                                                    {data?.Units}
                                                </p>
                                            </div>) : <></>}
                                    </div>
                                )
                            }
                            )}
                        </div> :
                        <>{noValExistText}</>}

                </div>}
            {isSignedOrToBeCoSigned.includes(data?.Data?.EncounterStatus) ?
                <div className="d-flex ">
                    <div className="ar-sign-new-design d-flex flex-column gap-1">
                        <div className="">
                            <SignImagePreview BucketPath={data?.Data?.SignaturePath} />
                        </div>
                        <p className="heading text-black">Electronically Signed By/Date:</p>
                        <p className='heading green-text'>{data?.Data?.ProviderSignBy || 'N/A'} on {signatureDateTimeFormatted || 'N/A'}</p>
                        {/* <div className="d-flex align-items-center gap-1">
                            <p className='heading text-black'>Sign Off Status:</p>
                            {(searchValue?.EncounterStatus === 'Signed' || data?.Data?.EncounterStatus === 'Signed') ?
                                <p className='Paid heading font-m ar-status-clm'>Signed</p> :
                                searchValue?.EncounterStatus === 'In Progress' ?
                                    <p className='Blue-Status heading font-m ar-status-clm'>In Progress</p> :
                                    searchValue?.EncounterStatus === 'Ready for Review' ?
                                        <p className='In-Review heading font-m ar-status-clm'>Ready for Review</p> :
                                        ['Unsigned', 'UnSigned'].includes(searchValue?.EncounterStatus) &&
                                        <p className='Not-Signed heading font-m ar-status-clm'>Unsigned</p>}
                        </div> */}
                    </div>
                </div>
                :
                null}
            {EncounterCoSignData?.map(it => 
                <SignData data={it}/>
            )}
            <div className='text-center pt-1-5 br-top-1 za_br_light'>
                <p className="text ar-light-color">Note Generated by {ThemeConfiguration?.configuration?.company?.name} (<a href="https://starhealthcare.co" className="ar-hover-text ar-light-color text" target="_blank" rel="noopener noreferrer" >https://starhealthcare.co</a>)</p>
                {/* <p className="text ar-light-color">Generated for Printing on: {formattedUTC}</p>
                <p className="text ar-light-color">Generated for Printing on: 11/6/2025 at 09:50 AM UTC</p> */}
                <p className="text ar-light-color">Printed by {data?.Data?.UserName || 'N/A'} on {formattedUTC}</p>
                {/* <p className="text ar-light-color">Generated for Printing on: {formattedUTCBottom}</p> */}
            </div>
        </div >
    </>)
}
export default SelectedPreviewDataV2